import React from 'react';
import { MATRIX_OUTCOME_COLS, getMatrixCellCount } from '../../utils/activityDashboardData';

const ACOLORS = ['#159c5f', '#22c55e', '#f59e0b', '#ab9bd6', '#fb7185', '#3186ba', '#f97316'];

export default function RepComparisonTable({ rows = [], rangeLabel = '', onCellClick }) {
  if (!rows.length) {
    return (
      <div style={{ textAlign: 'center', color: 'var(--text3)', fontSize: 13, padding: '24px 0' }}>
        Noch keine Anrufe im Zeitraum — logge Anrufe im Lead-Panel.
      </div>
    );
  }

  return (
    <div style={{ overflowX: 'auto', margin: '0 -4px' }}>
      <table style={{ width: '100%', minWidth: 640, borderCollapse: 'collapse', fontSize: 12 }}>
        <thead>
          <tr style={{ borderBottom: '2px solid var(--border)' }}>
            <th style={{ textAlign: 'left', padding: '8px 10px', fontSize: 10, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.06em', position: 'sticky', left: 0, background: 'var(--bg2)', zIndex: 1 }}>
              Mitarbeiter
            </th>
            {MATRIX_OUTCOME_COLS.map(col => (
              <th key={col.slug} style={{ textAlign: 'center', padding: '8px 8px', fontSize: 10, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => {
            const color = ACOLORS[ri % ACOLORS.length];
            return (
              <tr key={row.id} style={{ borderBottom: '1px solid var(--border)' }}>
                <td style={{ padding: '10px', fontWeight: 600, color: 'var(--text)', position: 'sticky', left: 0, background: 'var(--bg2)', zIndex: 1, whiteSpace: 'nowrap' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 }} />
                    {row.label}
                  </span>
                </td>
                {MATRIX_OUTCOME_COLS.map(col => {
                  const n = getMatrixCellCount(row, col);
                  const clickable = n > 0 && onCellClick;
                  return (
                    <td key={col.slug} style={{ textAlign: 'center', padding: '6px 4px' }}>
                      <button
                        type="button"
                        disabled={!clickable}
                        onClick={() => clickable && onCellClick({ row, col, count: n })}
                        style={{
                          minWidth: 36, height: 32, padding: '0 8px', borderRadius: 8,
                          border: `1px solid ${n > 0 ? 'var(--accent-border)' : 'transparent'}`,
                          background: n > 0 ? 'var(--accent-bg)' : 'transparent',
                          color: n > 0 ? 'var(--accent)' : 'var(--text3)',
                          fontWeight: 700, fontSize: 13, fontFamily: 'var(--mono)',
                          cursor: clickable ? 'pointer' : 'default',
                          opacity: n === 0 ? 0.45 : 1,
                        }}
                        title={clickable ? 'Anrufliste anzeigen' : ''}
                      >
                        {n}
                      </button>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 8 }}>
        {rangeLabel} · Zahl anklicken → Liste der Anrufe & Leads
      </div>
    </div>
  );
}
